import React, { Fragment } from "react";
import styles from "./Contacts2.module.scss";
import Layout from "../../layouts/Layout/Layout";
import { ContactForm } from "../../ui";
import { AddressBox, Button } from "../../elements";
import THEME from "../../../state/theme";
import { useCustomState } from "../../../state/state";

export default () => {
  const actions = useCustomState()[1];

  return (
    <Fragment>
      <div className={styles.header}>
        <span className="subtitle" style={{ color: THEME.color }}>
          Send message
        </span>
        <h2>Feel free to contact us.</h2>
        {/* <p>
          We believe in our team. We can provide to you strategic solutions to any problem in these industries, having direct impact on the bottom line.
        </p> */}
      </div>
      <Layout col="4">
        <AddressBox
          icon="las la-phone"
          title="Call Us"
          text="(775) 293-4695"
        />
        <AddressBox
          icon="la la-envelope-open"  
          title="Mail Us"
          text="info@techcsinc.com"
        />
        <AddressBox
          icon="la la-home"
          title="Visit Us" 
          text="4730 S. Fort Apache Road, Ste 300, Las Vegas Nevada 89147"
        />
        <AddressBox
          icon="las la-comment"
          title="Support"
          text="Live chart 24/7"
        />
        <span className={styles.divider} style={{ borderColor: THEME.color }} />
      </Layout>

      <Layout col="2">
        <div className={styles.wrapper}>
          <ContactForm style={{ border: "1px solid #eee" }} />
        </div>

        <div className={styles.info}>
          <i
            className="las la-long-arrow-alt-right"
            style={{ color: THEME.color }}
          />
          <h2>Contact us</h2>
          <p>
            
          </p>
          <Button
            click={() =>
              actions.toogleRequest(
                "I'm ready to start making business with you!"
              )
            }
            type="solid-gray-tb"
            hoverType="solid-white-tb"
            after="&#xf107;"
          >
            Get quote
          </Button>
        </div>
      </Layout>
    </Fragment>
  );
};
